import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const StyledTitleWrapper = styled.div`
  width: 100%;
  height: 30px;
  background-color: ${DIGIPOSTHEME.colors.headerRed};
  margin: 30px 0;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
`;

export const StyledBgWrapper = styled.div`
  width: 100%;
  background-color: ${DIGIPOSTHEME.colors.white};
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
`;

export const StyledIconCircle = styled.div`
  border-radius: 50%;
  background-color: ${DIGIPOSTHEME.colors.transparent};
  border: 1px solid #f5f4f6;
  box-shadow: rgb(0 0 0 / 14%) 0px 2px 2px 1px;
  padding: 10px;
  width: 52px;
  height: 52px;
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

export const StyledItemWrapper = styled.div`
  margin-bottom: 35px;
  padding: 15px 0;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
    rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 15px;
  }

  &:last-child {
    margin-bottom: 5px;
  }
`;
export const StyledContactDataWrapper = styled.div``;
